export default "__VITE_ASSET__DQpSZ7Rp__"